import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrButtonSwitchComponent } from './pr-button-switch.component';

@NgModule({
  imports: [CommonModule],
  exports: [PrButtonSwitchComponent],
  declarations: [PrButtonSwitchComponent],
})
export class PrButtonSwitchModule {}
